module.exports = __webpack_public_path__ + "static/img/zhuanshu.31ed741.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhuanshu.png
// module id = ErjF
// module chunks = 1